<template>
    <b-row v-if="options">
        <b-col v-if="options.isShowAddButton" md="auto">
          <b-button  @click.stop="ClickOnAddButton" variant="success">{{ $t('Add') }}</b-button>
        </b-col>
        <b-col v-if="options.isShowClearButton" md="auto">
          <b-button  @click.stop="ClickOnClearButton" variant="danger">{{ $t('Clear') }}</b-button>
        </b-col>
        <b-col v-if="options.isShowCheckButton" md="auto">
          <b-button  @click.stop="ClickOnCheckButton" variant="success">{{ $t('Check') }}</b-button>
        </b-col>
        <b-col v-if="options.isShowVerifyButton" md="auto">
          <b-button  @click.stop="ClickOnVerifyButton" variant="success">{{ $t('Verify') }}</b-button>
        </b-col>
        <b-col md="4">
          <b-row>
            <b-col>
              <b-form-group horizontal class="mb-0">
                  <b-input-group>
                      <b-form-input v-model="filter" :placeholder="$t('Type to Search')" @update="filterChanged" @keypress="pressEnterFilter"/>
                      <b-button size="sm" @click.stop="ClickOnSearchButton" id="transparent">
                        <b-img :src='searchDocumentImage' />
                      </b-button>
                  </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
            <b-form-group label-cols-sm="6" :label="$t('Per page')" >
                <b-form-select :options="pageOptions" style="min-width:60px" v-model="perPage" @change="paginationChanged"/>
            </b-form-group>
        </b-col>
        <b-col md="3" v-if="options.isCustomers">
          <b-form-select :options="customersOptions" v-model="curCustomers" @change="customersChanged"/>
        </b-col>
    </b-row>
</template>

<script>
export default {
  props: {
    options: {
      isShowAddButton: true,
      isShowClearButton: false,
      isShowCheckButton: false,
      isShowVerifyButton: false,
      isCustomers: false
    }
  },
  data () {
    return {
      curCustomers: 0,
      filter: '',
      customersOptions: [
        {value: 0, text: this.$i18n.t('Сommon\'s')},
        {value: 1, text: this.$i18n.t('Card\'s')}
      ],
      pageOptions: [20, 40, 60, 80, 100],
      perPage: 20,
      addDocumentImage: require('@/assets/img/file_add.png'),
      searchDocumentImage: require('@/assets/img/search.png')
    }
  },
  methods: {
    filterChanged () {
      this.$emit('filterChanged', this.filter)
    },
    paginationChanged () {
      this.$emit('paginationChanged', this.perPage)
    },
    customersChanged () {
      this.$emit('customersChanged', this.curCustomers)
    },
    ClickOnAddButton () {
      this.$emit('ClickOnAddButton')
    },
    ClickOnClearButton () {
      this.$emit('ClickOnClearButton')
    },
    ClickOnCheckButton () {
      this.$emit('ClickOnCheckButton')
    },
    ClickOnVerifyButton () {
      this.$emit('ClickOnVerifyButton')
    },
    ClickOnSearchButton () {
      this.$emit('ClickOnSearchButton')
    },
    pressEnterFilter (event) {
      if (event.keyCode === 13) {
        this.$emit('ClickOnSearchButton')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/TableManager.vue